import templateUrl from 'emun.salesrep/net-retailer-growth.htm';
import ServiceBusController from 'servicestack/service-bus.controller';
import resolve from 'ioc/resolve';
import AutoQuery from 'servicestack/auto-query/auto-query';

class NetRetailerGrowthController extends ServiceBusController {
  constructor() {
    super();
    const $ctrl = this;
    var context = $ctrl.context || 'rep';
    var queryAdditions = '';//'GroupBy=SalesRepRegion';  //this will be used by multiple queries

    var RepGroupBy = "";
    //if (context === "rep") {
    //  RepGroupBy = ",SalesRepName";
    //}
    //queryAdditions = queryAdditions + RepGroupBy;


    var repFilter = "";
    if (context !== 'writingRep') {
      if (context !== 'executive') {
        var filterType = "SalesRepID";
        if (context === 'manager') {
          filterType = 'ManagerId';
        }
        if ($ctrl.rep) {
          repFilter = "&" + filterType + "=" + $ctrl.rep.id;
        }
        else {
          repFilter = "&" + filterType + "=" + $ctrl.repId;
        }

      }
    }
    if ($ctrl.repGroup) {
      if ($ctrl.repGroup !== 'ALL') {
        queryAdditions = queryAdditions + '&RepGroupName=' + $ctrl.repGroup;
      }
    }
    if ($ctrl.insideSales) {
      if ($ctrl.insideSales === 'true') {
        queryAdditions = queryAdditions + '&IsInsideSales=true';
      }
    }
    if ($ctrl.context === "writingRep") {
      if ($ctrl.repId) {
        repFilter = "&SalesRepID=" + $ctrl.repId;
      }
      else {
        repFilter = "&WritingRepID=" + $ctrl.writingRepId;
      }

    }
    if (repFilter !== '') {
      queryAdditions = queryAdditions + repFilter;
    }

    var getDataUrl = 'QueryOrderTotalSummaries.json?Sum=CustomerCount,SalesTotal&GroupBy=SalesRepRegion,OrderYear&OrderBy=SalesRepRegion,OrderYear' + queryAdditions;


    $ctrl.NetRetailerGrowthCalulatedData = [];
    //const promises = [];

    //get the current year and last year
    const $q = resolve("$q");
    var d = new Date();
    var currentYear = d.getFullYear();
    var lastYear = d.getFullYear() - 1;
    //var queryAdditionsOrig = queryAdditions;
    const objGrandTotal = {
      Group: "Grand Total",
      currentYearCount: 0,
      lastYearCount: 0,
      countVar: 0,
      countVarPercent: 0,
      currentYearSales: 0,
      lastYearSales: 0,
      salesVar: 0,
      salesVarPercent: 0,
      tytdRetailerGoal: 0,
      goalVar: 0,
      goalVarPercent: 0,
      isBold: true
    };

    var RegionData = {};
    $ctrl.SalesBySegmentData = new AutoQuery({
      url: getDataUrl,
      autoLoad: true,
      pageSize: 100,
      scrollTop: false,
      onLoaded: function (resultsOrderTotals) {
        var percent = 0;
        resultsOrderTotals.results.forEach(function (OrderTotalItem) {
          percent = 0;

          RegionData.Group = (context === "rep") ? OrderTotalItem.salesRepName : OrderTotalItem.salesRepRegion;

          if (OrderTotalItem.orderYear === lastYear) {
            RegionData.lastYearCount = OrderTotalItem.sumCustomerCount;
            RegionData.lastYearSales = OrderTotalItem.sumSalesTotal;
          }

          if (OrderTotalItem.orderYear === currentYear) {
            RegionData.currentYearCount = OrderTotalItem.sumCustomerCount;
            RegionData.currentYearSales = OrderTotalItem.sumSalesTotal;

            //now that we have all of the year data, calculate the varances
            RegionData.countVar = RegionData.currentYearCount - RegionData.lastYearCount;

            //find the var percent for order counts
            percent = ((RegionData.currentYearCount / RegionData.lastYearCount) * 100) - 100;
            if (percent === Infinity) {
              percent = 100;
            }
            else {
              percent = percent.toFixed(2);
            }
            RegionData.countVarPercent = percent;
            RegionData.salesVar = Math.round(RegionData.currentYearSales - RegionData.lastYearSales);

            //find the var percent for sales totals
            percent = ((RegionData.currentYearSales / RegionData.lastYearSales) * 100) - 100;
            if (percent === Infinity) {
              percent = 100;
            }
            else {
              percent = percent.toFixed(2);
            }
            RegionData.salesVarPercent = percent;

            objGrandTotal.currentYearCount += RegionData.currentYearCount;
            objGrandTotal.lastYearCount += RegionData.lastYearCount;
            objGrandTotal.currentYearSales += RegionData.currentYearSales;
            objGrandTotal.lastYearSales += RegionData.lastYearSales;

            RegionData.tytdRetailerGoal = 0;
            RegionData.goalVar = 0;
            RegionData.goalVarPercent = 0;


            //add the completed data to the global array
            $ctrl.NetRetailerGrowthCalulatedData.push(RegionData);
            RegionData = {};
          }


        });
        //calculate the variance for the grand total
        objGrandTotal.countVar = objGrandTotal.currentYearCount - objGrandTotal.lastYearCount;

        //find the var percent for order counts
        percent = ((objGrandTotal.currentYearCount / objGrandTotal.lastYearCount) * 100) - 100;
        if (percent === Infinity) {
          percent = 100;
        }
        else {
          percent = percent.toFixed(2);
        }
        objGrandTotal.countVarPercent = percent;
        objGrandTotal.salesVar = Math.round(objGrandTotal.currentYearSales - objGrandTotal.lastYearSales);

        //find the var percent for sales totals
        percent = ((objGrandTotal.currentYearSales / objGrandTotal.lastYearSales) * 100) - 100;
        if (percent === Infinity) {
          percent = 100;
        }
        else {
          percent = percent.toFixed(2);
        }
        objGrandTotal.salesVarPercent = percent;

        //add it to the global arry
        $ctrl.NetRetailerGrowthCalulatedData.push(objGrandTotal);
      }
    });



    //$ctrl.bus.send(getDataUrl).then(({ data: { results } }) => {
    //  results.forEach(OrderTotalItem => {
    //    var obj = {};
    //    var percent = 0;

    //    //reset the criteria for each region
    //    queryAdditions = queryAdditionsOrig;
    //    obj.isBold = false;
    //    //we need to add a filter to the query to only pull customers from a particular region
    //    if (context === "rep") {
    //      //queryAdditions = queryAdditions + "&SalesRepID=" + OrderTotalItem.salesRepRegion;
    //    }
    //    else {
    //      queryAdditions = queryAdditions + "&SalesRepRegion=" + OrderTotalItem.salesRepRegion;
    //    }
    //    obj.Group = (context === "rep") ? OrderTotalItem.salesRepName : OrderTotalItem.salesRepRegion;

    //    //look up the customer count for last year
    //    var getLYTDCustomerCount = "QueryOrderTotalSummaries.json?CountDistinct=CustomerID&OrderYear=" + lastYear + queryAdditions;
    //    var getLYTDCustomerPromise = $ctrl.bus.send(getLYTDCustomerCount).then(resultsLYTDUniqueCustomer => {
    //      return resultsLYTDUniqueCustomer.data.results[0].countDistinctCustomerID;
    //    });


    //    //look up the customer count for this year
    //    var getCYTDCustomerCount = "QueryOrderTotalSummaries.json?CountDistinct=CustomerID&OrderYear=" + currentYear + queryAdditions;
    //    var getCYTDCustomerPromise = $ctrl.bus.send(getCYTDCustomerCount).then(resultsCYTDUniqueCustomers => {
    //      return resultsCYTDUniqueCustomers.data.results[0].countDistinctCustomerID;
    //    });

    //    //push these to an array so that we can wait until everything is done  
    //    promises.push(getLYTDCustomerPromise, getCYTDCustomerPromise);

    //    //use q to wait for all of the threads to finish. 
    //    //once done, complete the object and push on the array going to htm
    //    $q.all({ getLYTDCustomerPromise, getCYTDCustomerPromise }).then(promiseResults => {
    //      obj.lastYearCount = promiseResults.getLYTDCustomerPromise;
    //      obj.currentYearCount = promiseResults.getCYTDCustomerPromise;

    //      //console.info("promiseResults", promiseResults);
    //      obj.countVar = obj.currentYearCount - obj.lastYearCount;
    //      //console.info("obj", obj);

    //      //find the var percent for order counts
    //      percent = ((obj.currentYearCount / obj.lastYearCount) * 100) - 100;
    //      if (percent === Infinity) {
    //        percent = 100;
    //      }
    //      else {
    //        percent = percent.toFixed(2);
    //      }
    //      obj.countVarPercent = percent;
    //      obj.currentYearSales = Math.round(OrderTotalItem.sumCurrentYearSales);
    //      obj.lastYearSales = Math.round(OrderTotalItem.sumLastYearSales);
    //      obj.salesVar = Math.round(obj.currentYearSales - obj.lastYearSales);

    //      //find the var percent for sales totals
    //      percent = ((obj.currentYearSales / obj.lastYearSales) * 100) - 100;
    //      if (percent === Infinity) {
    //        percent = 100;
    //      }
    //      else {
    //        percent = percent.toFixed(2);
    //      }
    //      obj.salesVarPercent = percent;

    //      obj.tytdRetailerGoal = 0;
    //      obj.goalVar = 0;
    //      obj.goalVarPercent = 0;

    //      $ctrl.NetRetailerGrowthCalulatedData.push(obj);

    //      //update the grand total object to be used at the end if this is excutive
    //      objGrandTotal.currentYearCount += obj.currentYearCount;
    //      objGrandTotal.lastYearCount += obj.lastYearCount;
    //      objGrandTotal.currentYearSales += obj.currentYearSales;
    //      objGrandTotal.lastYearSales += obj.lastYearSales;
    //    });
    //  }); //for each

    //  //wait until everything is done (after all promises), then push the grand total array
    //  $q.all(promises).then(() => {
    //    if (context === "executive") {
    //      var percent;

    //      //calculate the var and var percent for customer count and sales
    //      objGrandTotal.countVar = objGrandTotal.currentYearCount - objGrandTotal.lastYearCount;
    //      percent = ((objGrandTotal.currentYearCount / objGrandTotal.lastYearCount) * 100) - 100;
    //      if (percent === Infinity) {
    //        percent = 100;
    //      }
    //      else {
    //        percent = percent.toFixed(2);
    //      }
    //      objGrandTotal.countVarPercent = percent;

    //      objGrandTotal.salesVar = Math.round(objGrandTotal.currentYearSales - objGrandTotal.lastYearSales);
    //      //find the var percent for sales totals
    //      percent = ((objGrandTotal.currentYearSales / objGrandTotal.lastYearSales) * 100) - 100;
    //      if (percent === Infinity) {
    //        percent = 100;
    //      }
    //      else {
    //        percent = percent.toFixed(2);
    //      }
    //      objGrandTotal.salesVarPercent = percent;

    //      //now add the grand total object to the array for the htm
    //      $ctrl.NetRetailerGrowthCalulatedData.push(objGrandTotal);
    //    }
    //  });

    //}); //first query

  }
}

let NetRetailerGrowth = {
  bindings: {
    repId: '@',
    repGroup: '@',
    context: '@',
    rep: '<',
    insideSales: '@',
    writingRepId: '@',
    repName: '@'
  },
  controller: NetRetailerGrowthController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};

export default NetRetailerGrowth;